<template>
    <div class="entrust-query">
        <div class="search-input">
            <a-input-search placeholder="请输入" size="large" @search="onSearch">
                <a-button slot="enterButton">查询</a-button>
            </a-input-search>
        </div>
        <div class="list-content">
            <tab :tabs="tabs"></tab>
            <a-table :columns="columns" :data-source="listData" :scroll="{ y: 376 }" :pagination="pagination">
                <template #action>
                    <a style="display: block" @click="toDetail">详情</a>
                    <a style="display: block" @click="toLogistics">物流信息</a>
                </template>
            </a-table>
        </div>

        <empty-result v-if="empty" />

        <result-card title="委托信息" v-if="empty">
            <template v-slot:tail>
                <a>查看详情 ></a>
            </template>
        </result-card>
    </div>
</template>

<script>
import tab from '@/components/tab.vue';
import emptyResult from './components/empty-result.vue';
import resultCard from './components/result-card.vue';

export default {
    components: {
        tab,
        emptyResult,
        resultCard
    },

    data() {
        const listData = [];
        for (let index = 0; index < 100; index++) {
            listData.push({
                key: index + 1,
                name: '测试',
                age: index + 1,
                address: '123'
            });
        }

        return {
            searching: false,
            empty: true,
            tabs: [
                { value: 'all', text: '全部', selected: true },
                { value: 'dsl', text: '待受理', selected: false },
                { value: 'dqz', text: '待签章', selected: false },
                { value: 'jcz', text: '检测中', selected: false },
                { value: 'ywc', text: '已完成', selected: false }
            ],

            columns: [
                { title: '委托单号', dataIndex: 'name', key: 'name' },
                { title: '委托状态', dataIndex: 'age', key: 'age' },
                { title: '委托日期', dataIndex: 'address', key: '1' },
                { title: '样品类型', dataIndex: 'address', key: '2' },
                { title: '样品名称', dataIndex: 'address', key: '3' },
                { title: '样品编号', dataIndex: 'address', key: '4' },
                { title: '采样方式', dataIndex: 'address', key: '5' },
                {
                    title: '操作',
                    key: 'operation',
                    width: 100,
                    scopedSlots: { customRender: 'action' }
                }
            ],

            listData,

            pagination: {
                total: listData.length,
                showQuickJumper: true,
                showSizeChanger: true,
                showTotal(total) {
                    return `总共${total}条`;
                },

                defaultCurrent: 1
            }
        };
    },
    methods: {
        onSearch() {},

        toDetail() {
            this.$router.push({ name: 'resultDetail', query: { lastRouteName: 'entrustQuery' } });
        },

        toLogistics() {
            this.$router.push({ name: 'logisticsInfo' });
        }
    }
};
</script>

<style lang="scss" scoped>
.entrust-query {
    .search-input {
        height: 80px;
        padding: 0 8px;
        display: flex;
        align-items: center;

        .ant-btn-lg {
            height: 48px;
            background: #005299;
            border: 1px solid rgba(0, 82, 153, 1);
            border-radius: 0px 4px 4px 0px;
            font-size: 18px;
            color: #ffffff;
            letter-spacing: 0;
            text-align: center;
            font-weight: 600;
            padding: 0 30px;
        }
    }
}
</style>
